import get from "lodash/get";

export const getSiteInfo = () => {
  if (window.moskitoSiteInfo) {
    return { ...window.moskitoSiteInfo };
  } else {
    console.warn("No global moskitoSiteInfo object.");
  }
  return {};
};

export const getPageInfo = () => {
  if (window.moskitoPageInfo) {
    return { ...window.moskitoPageInfo };
  } else {
    console.warn("No global moskitoPageInfo object.");
  }
  return {};
};

export const getMoskitoInfo = () => {
  if (window.moskitoPageInfo) {
    return { ...window.moskitoInfo };
  } else {
    console.warn("No global moskitoInfo object.");
  }
  return {};
};

export const getMoskitoApiJwt = async () => {
  return { data: "" };
};

export const getWpNonce = () => get(window, ["moskito", "nonce"]);
